import store from "../../../store/index";
import {
  getFavoriteNewsService,
  removeFavoriteArticleService,
  addFavoriteArticleService,
} from "../../Services/FavoriteService";
import {
  FAVORITE_NEWS,
  REMOVE_FAVOURITE,
  ADD_FAVOURITE,
  WHN_ARTICLES,
  ACCOUNTS_NEWS,
  SEARCH_ARTICLES,
  CURATION_HISTORY_SEARCH,
  CURATION_HISTORY,
  MOST_ENGAGED,
  ALL_ARTICLES_IN_EDITION,
  DRAG_DROP,
} from "../../../constants/actionTypes";
import { serializeArticles } from "../WhatsHappeningNow/utils";
import { IArticlesItem } from "../interfaces";
import { PREVIOUSLY_SENT_CONTENT } from "constants/types";

export const getFavoriteNews = (data: any) => {
  var form_data = new FormData();
  form_data.append("limit", JSON.stringify(data["result_limit"]));
  form_data.append("offset", JSON.stringify(data["result_offset"]));
  store.dispatch({
    type: FAVORITE_NEWS.LOAD,
  });
  getFavoriteNewsService(data["result_limit"], data["result_offset"], data["emailId"])
    .then((res) => {
      const serializedData: IArticlesItem[] = serializeArticles(res.data);
      store.dispatch({
        type: FAVORITE_NEWS.LOAD_SUCCESS,
        payload: serializedData,
      });
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: FAVORITE_NEWS.LOAD_FAIL,
        payload: Array<IArticlesItem>(),
      });
      // show error alert on frontend
    });
};

export const removeFavoriteArticle = (articleId: number) => {
  store.dispatch({
    type: REMOVE_FAVOURITE.LOAD,
    payload: articleId,
  });

  removeFavoriteArticleService(articleId)
    .then((res) => {
      store.dispatch({
        type: PREVIOUSLY_SENT_CONTENT.REMOVE_FAVOURITE,
        payload: articleId,
      });
      store.dispatch({
        type: WHN_ARTICLES.REMOVE_FAVOURITE,
        payload: articleId,
      });

      store.dispatch({
        type: ACCOUNTS_NEWS.REMOVE_FAVOURITE,
        articleId: articleId,
      });
      store.dispatch({
        type: SEARCH_ARTICLES.REMOVE_FAVOURITE,
        payload: articleId,
      });
      store.dispatch({
        type: CURATION_HISTORY_SEARCH.REMOVE_FAVOURITE,
        payload: articleId,
      });
      store.dispatch({
        type: MOST_ENGAGED.REMOVE_FAVOURITE,
        payload: articleId,
      });
      if (res.data.success === true) {
        store.dispatch({
          type: REMOVE_FAVOURITE.LOAD_SUCCESS,
          payload: articleId,
        });
        store.dispatch({
          type: ALL_ARTICLES_IN_EDITION.REMOVE_FAVORTIE_IN_EDITIONS,
          payload: { articleId: articleId },
        });
      } else {
        store.dispatch({
          type: REMOVE_FAVOURITE.LOAD_FAIL,
        });
      }
      if (window.location.pathname.includes("favourites")) {
        store.dispatch({
          type: DRAG_DROP.SET_SELECTED_ID,
          payload: { add: false, id: articleId },
        });
      }
    })
    .catch((err) => {
      console.log(err);
      console.log("remove curated article error : ", err);
      store.dispatch({
        type: REMOVE_FAVOURITE.LOAD_FAIL,
      });
      // show error alert on frontend
    });
};

export const addFavouriteArticle = (articleId: number, isCurated = false) => {
  store.dispatch({ type: ADD_FAVOURITE.LOAD, payload: articleId });
  addFavoriteArticleService(articleId)
    .then((res) => {
      /* show icon in the what happening now list */

      store.dispatch({
        type: CURATION_HISTORY.ADD_FAVOURITE,
        payload: articleId,
      });
      store.dispatch({
        type: WHN_ARTICLES.ADD_FAVOURITE,
        payload: articleId,
      });
      store.dispatch({
        type: ACCOUNTS_NEWS.ADD_FAVOURITE,
        articleId: articleId,
      });
      store.dispatch({
        type: SEARCH_ARTICLES.ADD_FAVOURITE,
        payload: articleId,
      });
      store.dispatch({
        type: CURATION_HISTORY_SEARCH.ADD_FAVOURITE,
        payload: articleId,
      });
      store.dispatch({
        type: MOST_ENGAGED.ADD_FAVOURITE,
        payload: articleId,
      });

      //*  updating the previously sent articles of assets here
      store.dispatch({
        type: PREVIOUSLY_SENT_CONTENT.ADD_FAVOURITE,
        payload: articleId,
      });
      if (res.data.length !== 0) {
        const serializedData: IArticlesItem[] = serializeArticles(res.data);
        store.dispatch({
          type: ADD_FAVOURITE.LOAD_SUCCESS,
          payload: serializedData[0],
        });
        store.dispatch({
          type: ALL_ARTICLES_IN_EDITION.ADD_FAVORTIE_IN_EDITIONS,
          payload: { articleId: articleId },
        });
      } else {
        store.dispatch({
          type: ADD_FAVOURITE.LOAD_FAIL,
        });
      }
      if (isCurated) {
        addCurateFavoriteArticle(articleId);
      }
    })
    .catch((err) => {
      console.log(err);
      console.log("api failed for Add to favourite api : ", err);
      store.dispatch({
        type: ADD_FAVOURITE.LOAD_FAIL,
      });
      // show error alert on frontend
    });
};

export const RemoveCurateFavoriteArticle = (articleId: number) => {
  store.dispatch({
    type: FAVORITE_NEWS.REMOVE_CURATE,
    curate_article_id: articleId,
  });
};

export const RemoveAllCurateFavoriteArticle = () => {
  store.dispatch({
    type: FAVORITE_NEWS.REMOVE_ALL_CURATE,
  });
};

export const addCurateFavoriteArticle = (articleId: number) => {
  store.dispatch({
    type: FAVORITE_NEWS.ADD_CURATE,
    curate_article_id: articleId,
  });
};

export const resetFavoriteArticles = () => {
  store.dispatch({
    type: FAVORITE_NEWS.RESET,
  });
};
